export const JOB_POSITION_FEATURES = ['hasFastResponse', 'hasTopSalary', 'isNewChance'] as const;
export type JobPositionFeature = (typeof JOB_POSITION_FEATURES)[number];
export type JobPositionFeatures = Partial<Record<JobPositionFeature, boolean>>;

export const JOB_POSITION_FEATURES_EVENT_PROPERTIES: { key: JobPositionFeature; property: string }[] = [
  { key: 'hasFastResponse', property: 'fast_response' },
  { key: 'hasTopSalary', property: 'top_salary' },
  { key: 'isNewChance', property: 'new_chance' },
];
